<template>
  <div>
    <vuetable ref="vuetable" :data="dataTable" :fields="dataFields">
      <template slot="nom" slot-scope="props">
        <b-link :to="'../mes-tableaux/' + props.rowData.id"
          >{{ props.rowData.nom }}
          <sup class="sup-link-icon" title="Voir projet"
            ><font-awesome-icon :icon="['fas', 'external-link-alt']"/></sup
        ></b-link>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="action-client" v-if="props.rowData.nom !== 'Templates'">
          <ul class="d-flex">
            <li>
              <b-link
                @click.prevent="
                  handleEdit('edit', props.rowData, props.rowIndex)
                "
                title="Editer projet"
                ><font-awesome-icon :icon="['far', 'edit']"
              /></b-link>
            </li>
            <li>
              <span
                @click.prevent="
                  handleDelete('delete', props.rowData, props.rowIndex)
                "
                :style="{ color: 'red', cursor: 'pointer' }"
                title="Supprimer projet"
                ><font-awesome-icon :icon="['far', 'trash-alt']"
              /></span>
            </li>
          </ul>
        </div>
      </template>
    </vuetable>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    dataTable: {
      type: undefined
    },
    dataFields: {
      type: undefined
    }
  },
  methods: {
    ...mapActions(['deleteProject']),
    handleDelete (action, data, index) {
      this.$emit('deleteAction', data.id)
    },
    handleEdit (action, data, index) {
      this.$emit('editAction', data.id)
    }
  }
}
</script>
<style lang="scss">
.action-client {
  ul {
    padding-left: 0;
    list-style: none;
    margin-bottom: 0;
    li {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
.sup-link-icon {
  padding-left: 5px;
  font-size: 9px;
  top: -7px;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/tableListing.vue